// import { useMutation } from "@tanstack/react-query"
// import { chatService } from "../services/chatService"

// export const usePrompt = () => {
//     return useMutation<any, Error, { prompt: string }>({
//         mutationFn : ({ prompt }) => chatService.sendPrompt(prompt),
//         mutationKey: ["prompt"],
//     })
// }


// // hooks/useChatHooks.ts
// import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
// import { message } from 'antd';
// import { chatService, ConversationItem, MessageHistory, CreateConversationRequest, SaveMessageRequest } from '../services/chatService';

// // Query Keys
// export const CHAT_QUERY_KEYS = {
//   conversations: ['conversations'] as const,
//   conversation: (id: string) => ['conversation', id] as const,
//   messages: (conversationId: string) => ['messages', conversationId] as const,
// };

// // Get all conversations
// export const useConversations = () => {
//   return useQuery({
//     queryKey: CHAT_QUERY_KEYS.conversations,
//     queryFn: async () => {
//       try {
//         return await chatService.getConversations();
//       } catch (error) {
//         console.error('Error fetching conversations:', error);
//         message.error('Failed to load conversations');
//         throw error;
//       }
//     },
//   });
// };

// // Get conversation with messages
// export const useConversation = (conversationId: string | undefined) => {
//   return useQuery({
//     queryKey: CHAT_QUERY_KEYS.conversation(conversationId || ''),
//     queryFn: () => chatService.getConversation(conversationId!),
//     enabled: !!conversationId,
//   });
// };

// // Create new conversation
// export const useCreateConversation = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: (request: CreateConversationRequest) => chatService.createConversation(request),
//     onSuccess: (_data: ConversationItem) => {
//       // Invalidate and refetch conversations
//       queryClient.invalidateQueries({ queryKey: CHAT_QUERY_KEYS.conversations });
//       message.success('Conversation created successfully!');
//     },
//     onError: (error: Error) => {
//       console.error('Error creating conversation:', error);
//       message.error('Failed to create conversation. Please try again.');
//     },
//   });
// };

// // Delete conversation
// export const useDeleteConversation = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: (conversationId: string) => chatService.deleteConversation(conversationId),
//     onSuccess: (_, conversationId) => {
//       // Remove from cache
//       queryClient.removeQueries({ queryKey: CHAT_QUERY_KEYS.conversation(conversationId) });
//       queryClient.removeQueries({ queryKey: CHAT_QUERY_KEYS.messages(conversationId) });
      
//       // Invalidate conversations list
//       queryClient.invalidateQueries({ queryKey: CHAT_QUERY_KEYS.conversations });
      
//       message.success('Conversation deleted successfully');
//     },
//     onError: (error: Error) => {
//       console.error('Error deleting conversation:', error);
//       message.error('Failed to delete conversation. Please try again.');
//     },
//   });
// };

// // Save message to conversation
// export const useSaveMessage = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: (request: SaveMessageRequest) => chatService.saveMessage(request),
//     onSuccess: (data, variables) => {
//       // Update conversation cache with new message
//       queryClient.setQueryData(
//         CHAT_QUERY_KEYS.conversation(variables.conversationId),
//         (oldData: any) => {
//           if (!oldData) return oldData;
//           return {
//             ...oldData,
//             messages: [...(oldData.messages || []), data],
//           };
//         }
//       );
//     },
//     onError: (error: Error) => {
//       console.error('Error saving message:', error);
//       // Don't show error to user as this is a background operation
//     },
//   });
// };

// // Send prompt for analysis
// export const usePrompt = () => {
//   return useMutation<any, Error, { prompt: string }>({
//     mutationFn: ({ prompt }) => chatService.sendPrompt(prompt),
//     mutationKey: ['prompt'],
//     onError: (error: Error) => {
//       console.error('Error sending prompt:', error);
//       message.error('Failed to analyze prompt. Please try again.');
//     },
//   });
// };

// // Update conversation title
// export const useUpdateConversation = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: ({ conversationId, title }: { conversationId: string; title: string }) => 
//       chatService.updateConversation(conversationId, title),
//     onSuccess: (updatedConversation) => {
//       // Update conversation in cache
//       queryClient.setQueryData(
//         CHAT_QUERY_KEYS.conversation(updatedConversation.id),
//         (oldData: any) => {
//           if (!oldData) return oldData;
//           return {
//             ...oldData,
//             conversation: updatedConversation,
//           };
//         }
//       );
      
//       // Invalidate conversations list to refresh it
//       queryClient.invalidateQueries({ queryKey: CHAT_QUERY_KEYS.conversations });
      
//       message.success('Conversation updated successfully');
//     },
//     onError: (error: Error) => {
//       console.error('Error updating conversation:', error);
//       message.error('Failed to update conversation. Please try again.');
//     },
//   });
// };

// // Custom hook for optimistic updates
// export const useOptimisticMessage = () => {
//   const queryClient = useQueryClient();

//   const addOptimisticMessage = (conversationId: string, message: Partial<MessageHistory>) => {
//     queryClient.setQueryData(
//       CHAT_QUERY_KEYS.conversation(conversationId),
//       (oldData: any) => {
//         if (!oldData) return oldData;
//         const optimisticMessage: MessageHistory = {
//           id: `temp-${Date.now()}`,
//           conversationId,
//           role: message.role || 'user',
//           content: message.content || '',
//           parts: message.parts || [{ type: 'text', text: message.content || '' }],
//           createdAt: new Date().toISOString(),
//         };
//         return {
//           ...oldData,
//           messages: [...(oldData.messages || []), optimisticMessage],
//         };
//       }
//     );
//   };

//   const removeOptimisticMessage = (conversationId: string, messageId: string) => {
//     queryClient.setQueryData(
//       CHAT_QUERY_KEYS.conversation(conversationId),
//       (oldData: any) => {
//         if (!oldData) return oldData;
//         return {
//           ...oldData,
//           messages: (oldData.messages || []).filter((msg: MessageHistory) => msg.id !== messageId),
//         };
//       }
//     );
//   };

//   return { addOptimisticMessage, removeOptimisticMessage };
// };

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { chatService, ConversationItem, MessageHistory, CreateConversationRequest, SaveMessageRequest } from '../services/chatService';
import React from 'react';

// Query Keys
export const CHAT_QUERY_KEYS = {
  conversations: ['conversations'] as const,
  conversation: (id: string) => ['conversation', id] as const,
  messages: (conversationId: string) => ['messages', conversationId] as const,
};


// Get all conversations
export const useConversations = (options: { enabled?: boolean } = {}) => {
  const { enabled = true } = options;
  
  return useQuery({
    queryKey: CHAT_QUERY_KEYS.conversations,
    queryFn: async () => {
      try {
        return await chatService.getConversations();
      } catch (error) {
        console.error('Error fetching conversations:', error);
        message.error('Failed to load conversations');
        throw error;
      }
    },
    enabled: enabled, // Only run the query when enabled is true
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
};

// Get conversation with messages
export const useConversation = (conversationId: string | undefined) => {
  return useQuery({
    queryKey: CHAT_QUERY_KEYS.conversation(conversationId || ''),
    queryFn: async () => {
      if (!conversationId) throw new Error('Conversation ID is required');
      try {
        return await chatService.getConversation(conversationId);
      } catch (error) {
        console.error('Error fetching conversation:', error);
        message.error('Failed to load conversation');
        throw error;
      }
    },
    enabled: !!conversationId,
    staleTime: 1 * 60 * 1000, // 1 minute
    retry: 2,
  });
};

// Create new conversation
export const useCreateConversation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: CreateConversationRequest) => {
      try {
        return await chatService.createConversation(request);
      } catch (error) {
        console.error('Error creating conversation:', error);
        throw error;
      }
    },
    onSuccess: (data: ConversationItem) => {
      // Add the new conversation to the cache
      queryClient.setQueryData(
        CHAT_QUERY_KEYS.conversations,
        (oldData: ConversationItem[] | undefined) => {
          if (!oldData) return [data];
          return [data, ...oldData];
        }
      );

      // Initialize the conversation data in cache
      queryClient.setQueryData(
        CHAT_QUERY_KEYS.conversation(data.id),
        {
          conversation: data,
          messages: [],
        }
      );

      message.success('Conversation created successfully!');
    },
    onError: (error: Error) => {
      console.error('Error creating conversation:', error);
      message.error('Failed to create conversation. Please try again.');
    },
  });
};

// Delete conversation
export const useDeleteConversation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (conversationId: string) => {
      try {
        return await chatService.deleteConversation(conversationId);
      } catch (error) {
        console.error('Error deleting conversation:', error);
        throw error;
      }
    },
    onMutate: async (conversationId: string) => {
      // Cancel any outgoing refetches
      await queryClient.cancelQueries({ queryKey: CHAT_QUERY_KEYS.conversations });

      // Snapshot the previous value
      const previousConversations = queryClient.getQueryData(CHAT_QUERY_KEYS.conversations);

      // Optimistically update the conversations list
      queryClient.setQueryData(
        CHAT_QUERY_KEYS.conversations,
        (oldData: ConversationItem[] | undefined) => {
          if (!oldData) return [];
          return oldData.filter(conv => conv.id !== conversationId);
        }
      );

      return { previousConversations };
    },
    onError: (error: Error, _conversationId: string, context) => {
      // Rollback on error
      if (context?.previousConversations) {
        queryClient.setQueryData(CHAT_QUERY_KEYS.conversations, context.previousConversations);
      }
      console.error('Error deleting conversation:', error);
      message.error('Failed to delete conversation. Please try again.');
    },
    onSuccess: (_, conversationId) => {
      // Remove from cache
      queryClient.removeQueries({ queryKey: CHAT_QUERY_KEYS.conversation(conversationId) });
      queryClient.removeQueries({ queryKey: CHAT_QUERY_KEYS.messages(conversationId) });
      
      message.success('Conversation deleted successfully');
    },
    onSettled: () => {
      // Always refetch conversations to ensure consistency
      queryClient.invalidateQueries({ queryKey: CHAT_QUERY_KEYS.conversations });
    },
  });
};

// Simplified save message hook with deduplication
export const useSaveMessage = () => {
  const queryClient = useQueryClient();
  const pendingMessages = React.useRef<Set<string>>(new Set());

  return useMutation({
    mutationFn: async (request: SaveMessageRequest & { skipOptimistic?: boolean; messageId?: string }) => {
      const messageKey = `${request.conversationId}-${request.role}-${request.content.slice(0, 50)}`;
      
      // Prevent duplicate saves
      if (pendingMessages.current.has(messageKey)) {
        return null;
      }
      
      pendingMessages.current.add(messageKey);
      
      try {
        const result = await chatService.saveMessage(request);
        return result;
      } catch (error) {
        console.error('Error saving message:', error);
        throw error;
      } finally {
        // Remove from pending after a delay to prevent rapid duplicates
        setTimeout(() => {
          pendingMessages.current.delete(messageKey);
        }, 1000);
      }
    },
    onMutate: async (variables: SaveMessageRequest & { skipOptimistic?: boolean; messageId?: string }) => {
      // Skip optimistic updates if requested
      if (variables.skipOptimistic) {
        return {};
      }

      // Cancel any outgoing refetches
      await queryClient.cancelQueries({ 
        queryKey: CHAT_QUERY_KEYS.conversation(variables.conversationId) 
      });

      // Snapshot the previous value
      const previousData = queryClient.getQueryData(
        CHAT_QUERY_KEYS.conversation(variables.conversationId)
      );

      // Create optimistic message
      const optimisticMessage: MessageHistory = {
        id: variables.messageId || `temp-${Date.now()}-${Math.random()}`,
        conversationId: variables.conversationId,
        role: variables.role,
        content: variables.content,
        parts: variables.parts,
        createdAt: new Date().toISOString(),
        toolInvocations: []
      };

      // Optimistically update the conversation
      queryClient.setQueryData(
        CHAT_QUERY_KEYS.conversation(variables.conversationId),
        (oldData: any) => {
          if (!oldData) return oldData;
          
          // Check if message already exists to prevent duplicates
          const messageExists = oldData.messages?.some((msg: MessageHistory) => 
            msg.id === optimisticMessage.id || 
            (msg.role === variables.role && msg.content === variables.content)
          );
          
          if (messageExists) {
            return oldData;
          }
          
          return {
            ...oldData,
            messages: [...(oldData.messages || []), optimisticMessage],
          };
        }
      );

      return { previousData, optimisticMessage };
    },
    onError: (error: Error, variables, context) => {
      // Rollback on error
      if (context?.previousData) {
        queryClient.setQueryData(
          CHAT_QUERY_KEYS.conversation(variables.conversationId),
          context.previousData
        );
      }
      console.error('Error saving message:', error);
      message.error('Failed to save message');
    },
    onSuccess: (data, variables, context) => {
      // Skip if the mutation returned null (duplicate)
      if (!data) return;

      // Replace optimistic message with real one, or just add if no optimistic message
      queryClient.setQueryData(
        CHAT_QUERY_KEYS.conversation(variables.conversationId),
        (oldData: any) => {
          if (!oldData) return oldData;
          
          const messages = oldData.messages || [];
          
          if (context?.optimisticMessage) {
            // Replace optimistic message
            const updatedMessages = messages.map((msg: MessageHistory) => 
              msg.id === context.optimisticMessage?.id ? data : msg
            );
            return {
              ...oldData,
              messages: updatedMessages,
            };
          } else {
            // Check if message already exists before adding
            const messageExists = messages.some((msg: MessageHistory) => 
              msg.id === data.id || 
              (msg.role === data.role && msg.content === data.content && msg.conversationId === data.conversationId)
            );
            
            if (!messageExists) {
              return {
                ...oldData,
                messages: [...messages, data],
              };
            }
            return oldData;
          }
        }
      );
    },
  });
};

// Send prompt for analysis
export const usePrompt = () => {
  return useMutation<any, Error, { prompt: string }>({
    mutationFn: async ({ prompt }) => {
      try {
        return await chatService.sendPrompt(prompt);
      } catch (error) {
        console.error('Error sending prompt:', error);
        throw error;
      }
    },
    mutationKey: ['prompt'],
    onError: (error: Error) => {
      console.error('Error sending prompt:', error);
      message.error('Failed to analyze prompt. Please try again.');
    },
  });
};

// Update conversation title
export const useUpdateConversation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ conversationId, title }: { conversationId: string; title: string }) => {
      try {
        return await chatService.updateConversation(conversationId, title);
      } catch (error) {
        console.error('Error updating conversation:', error);
        throw error;
      }
    },
    onMutate: async ({ conversationId, title }) => {
      // Cancel any outgoing refetches
      await queryClient.cancelQueries({ queryKey: CHAT_QUERY_KEYS.conversations });
      await queryClient.cancelQueries({ queryKey: CHAT_QUERY_KEYS.conversation(conversationId) });

      // Snapshot the previous values
      const previousConversations = queryClient.getQueryData(CHAT_QUERY_KEYS.conversations);
      const previousConversation = queryClient.getQueryData(CHAT_QUERY_KEYS.conversation(conversationId));

      // Optimistically update conversations list
      queryClient.setQueryData(
        CHAT_QUERY_KEYS.conversations,
        (oldData: ConversationItem[] | undefined) => {
          if (!oldData) return oldData;
          return oldData.map(conv => 
            conv.id === conversationId ? { ...conv, title } : conv
          );
        }
      );

      // Optimistically update conversation
      queryClient.setQueryData(
        CHAT_QUERY_KEYS.conversation(conversationId),
        (oldData: any) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            conversation: { ...oldData.conversation, title },
          };
        }
      );

      return { previousConversations, previousConversation };
    },
    onError: (error: Error, variables, context) => {
      // Rollback on error
      if (context?.previousConversations) {
        queryClient.setQueryData(CHAT_QUERY_KEYS.conversations, context.previousConversations);
      }
      if (context?.previousConversation) {
        queryClient.setQueryData(
          CHAT_QUERY_KEYS.conversation(variables.conversationId),
          context.previousConversation
        );
      }
      console.error('Error updating conversation:', error);
      message.error('Failed to update conversation. Please try again.');
    },
    onSuccess: (updatedConversation, variables) => {
      // Update with server response
      queryClient.setQueryData(
        CHAT_QUERY_KEYS.conversation(variables.conversationId),
        (oldData: any) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            conversation: updatedConversation,
          };
        }
      );

      queryClient.setQueryData(
        CHAT_QUERY_KEYS.conversations,
        (oldData: ConversationItem[] | undefined) => {
          if (!oldData) return oldData;
          return oldData.map(conv => 
            conv.id === variables.conversationId ? updatedConversation : conv
          );
        }
      );
      
      message.success('Conversation updated successfully');
    },
    onSettled: (_, __, variables) => {
      // Invalidate to ensure server state consistency
      queryClient.invalidateQueries({ queryKey: CHAT_QUERY_KEYS.conversations });
      queryClient.invalidateQueries({ queryKey: CHAT_QUERY_KEYS.conversation(variables.conversationId) });
    },
  });
};

// Improved optimistic message hook with better state management
export const useOptimisticMessage = () => {
  const queryClient = useQueryClient();
  const optimisticMessages = React.useRef<Map<string, string>>(new Map());

  const addOptimisticMessage = (conversationId: string, message: Partial<MessageHistory>) => {
    const messageId = `temp-${Date.now()}-${Math.random()}`;
    const messageKey = `${conversationId}-${message.role}-${message.content?.slice(0, 50)}`;
    
    // Prevent duplicate optimistic messages
    if (optimisticMessages.current.has(messageKey)) {
      return optimisticMessages.current.get(messageKey)!;
    }
    
    optimisticMessages.current.set(messageKey, messageId);
    
    const optimisticMessage: MessageHistory = {
      id: messageId,
      conversationId,
      role: message.role || 'user',
      content: message.content || '',
      parts: message.parts || [{ type: 'text', text: message.content || '' }],
      createdAt: new Date().toISOString(),
      toolInvocations: []
    };

    queryClient.setQueryData(
      CHAT_QUERY_KEYS.conversation(conversationId),
      (oldData: any) => {
        if (!oldData) return oldData;
        
        // Check if message already exists
        const messageExists = oldData.messages?.some((msg: MessageHistory) => 
          msg.id === messageId || 
          (msg.role === message.role && msg.content === message.content)
        );
        
        if (messageExists) {
          return oldData;
        }
        
        return {
          ...oldData,
          messages: [...(oldData.messages || []), optimisticMessage],
        };
      }
    );

    // Clean up after a delay
    setTimeout(() => {
      optimisticMessages.current.delete(messageKey);
    }, 5000);

    return messageId;
  };

  const removeOptimisticMessage = (conversationId: string, messageId: string) => {
    queryClient.setQueryData(
      CHAT_QUERY_KEYS.conversation(conversationId),
      (oldData: any) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          messages: (oldData.messages || []).filter((msg: MessageHistory) => msg.id !== messageId),
        };
      }
    );
  };

  const updateOptimisticMessage = (conversationId: string, messageId: string, updates: Partial<MessageHistory>) => {
    queryClient.setQueryData(
      CHAT_QUERY_KEYS.conversation(conversationId),
      (oldData: any) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          messages: (oldData.messages || []).map((msg: MessageHistory) => 
            msg.id === messageId ? { ...msg, ...updates } : msg
          ),
        };
      }
    );
  };

  return { addOptimisticMessage, removeOptimisticMessage, updateOptimisticMessage };
};

// Hook for real-time message updates (if you implement WebSocket)
export const useMessageSubscription = (conversationId: string | undefined) => {
  const queryClient = useQueryClient();

  React.useEffect(() => {
    if (!conversationId) return;

    // This is where you would set up WebSocket connection
    // const ws = new WebSocket(`ws://localhost:3000/ws/conversations/${conversationId}`);
    
    // ws.onmessage = (event) => {
    //   const message = JSON.parse(event.data);
    //   queryClient.setQueryData(
    //     CHAT_QUERY_KEYS.conversation(conversationId),
    //     (oldData: any) => {
    //       if (!oldData) return oldData;
    //       return {
    //         ...oldData,
    //         messages: [...(oldData.messages || []), message],
    //       };
    //     }
    //   );
    // };

    // return () => {
    //   ws.close();
    // };
  }, [conversationId, queryClient]);
};

// Hook for conversation statistics
export const useConversationStats = () => {
  const { data: conversations } = useConversations();

  return React.useMemo(() => {
    if (!conversations) return null;

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const todayCount = conversations.filter(conv => {
      const convDate = new Date(conv.createdAt);
      return convDate.toDateString() === today.toDateString();
    }).length;

    const yesterdayCount = conversations.filter(conv => {
      const convDate = new Date(conv.createdAt);
      return convDate.toDateString() === yesterday.toDateString();
    }).length;

    return {
      total: conversations.length,
      today: todayCount,
      yesterday: yesterdayCount,
      thisWeek: conversations.filter(conv => {
        const convDate = new Date(conv.createdAt);
        const weekAgo = new Date(today);
        weekAgo.setDate(weekAgo.getDate() - 7);
        return convDate >= weekAgo;
      }).length,
    };
  }, [conversations]);
};